import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import ThemeContext from '../../../../../ThemeContext';

const ConfirmDeleteModal = ({ show, onHide, onConfirm, itemCount, itemType }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        style={{
          backgroundColor: theme.colors.danger,
          color: theme.colors.textWhite,
          borderBottom: 'none',
        }}
      >
        <Modal.Title style={{ fontSize: 'clamp(12px, 2.5vw, 14px)' }}>
          Confirm Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          backgroundColor: theme.colors.bgPrimary,
          color: theme.colors.textPrimary,
        }}
      >
        <p style={{ fontSize: 'clamp(9px, 2vw, 10px)', margin: 0 }}>
          Are you sure you want to delete {itemCount} {itemType}(s)?
        </p>
        <p style={{ fontSize: 'clamp(9px, 2vw, 10px)', marginTop: '0.5rem', color: theme.colors.danger }}>
          This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer
        style={{
          backgroundColor: theme.colors.bgPrimary,
          borderTop: `1px solid ${theme.colors.borderColor}`,
        }}
      >
        <button
          onClick={onHide}
          style={{
            padding: 'clamp(6px, 2vw, 8px) clamp(12px, 3vw, 16px)',
            fontSize: 'clamp(9px, 2vw, 10px)',
            border: `1px solid ${theme.colors.borderColor}`,
            borderRadius: '5px',
            backgroundColor: theme.colors.bgSecondary,
            color: theme.colors.textPrimary,
            cursor: 'pointer',
          }}
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          style={{
            padding: 'clamp(6px, 2vw, 8px) clamp(12px, 3vw, 16px)',
            fontSize: 'clamp(9px, 2vw, 10px)',
            border: 'none',
            borderRadius: '5px',
            backgroundColor: theme.colors.danger,
            color: theme.colors.textWhite,
            cursor: 'pointer',
          }}
        >
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;